import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";

import { Action, Selector, StateContext, State } from "@ngxs/store";
import { LocationService } from "../../services/location/location.service";
import { LocationDevicesGraphs } from "./location_devices_graphs.actions";
import { tap, finalize } from "rxjs";

export class LocationDeviceGrapEntry {
	filter: {
		from: "";
		to: "";
	};
}

export class LocationDevicesGraphsStateModel {
	location_devices_graphs: {
		[key: string]: { [key: string]: { [key: string]: { [key: string]: { [key: string]: LocationDeviceGrapEntry } } } };
	};
	loading: boolean;
}

@State<LocationDevicesGraphsStateModel>({
	name: "locationdevicesgraphsstate",
	defaults: {
		location_devices_graphs: {},
		// selectedGraph: {},
		loading: false,
	},
})
@Injectable()
export class LocationDevicesGraphsState {
	constructor(private locationService: LocationService) {}

	@Selector()
	static getLocationDevicesGraphs(state: LocationDevicesGraphsStateModel) {
		return (location_id?: number, device_id?: number, component?: string, capability?: string, attribute?: string) => {
			let result: any;
			result = state.location_devices_graphs;

			if (location_id) result = result[location_id];
			if (result && device_id) result = result[device_id];
			if (result && component) result = result[component];
			if (result && capability) result = result[capability];
			if (result && attribute) result = result[attribute];

			return result;
		};
	}

	@Selector()
	static loading(state: LocationDevicesGraphsStateModel) {
		return state.loading;
	}

	@Action(LocationDevicesGraphs.SetFilter)
	setFilter(ctx: StateContext<LocationDevicesGraphsStateModel>, action: LocationDevicesGraphs.SetFilter) {
		// const state = ctx.getState();
		// let graphsTree = {};
		// if (state.location_devices_graphs[action.location_id] && state.location_devices_graphs[action.location_id][action.device_id]) {
		// 	graphsTree = {
		// 		[action.location_id]: {
		// 			[action.device_id]: {
		// 				...state.location_devices_graphs[action.location_id][action.device_id],
		// 				filter: {
		// 					...action.filter,
		// 				},
		// 			},
		// 		},
		// 	};
		// } else {
		// 	graphsTree = {
		// 		[action.location_id]: {
		// 			[action.device_id]: {
		// 				filter: {
		// 					...action.filter,
		// 				},
		// 			},
		// 		},
		// 	};
		// }
		// ctx.patchState({
		// 	...state,
		// 	location_devices_graphs: {
		// 		...state.location_devices_graphs,
		// 		...graphsTree,
		// 	},
		// });
	}
}
